let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("55oBx")).then(() => parcelRequire('iWBIA'));